import React from 'react';

const EquipmentStatusTable = ({ equipmentStatusData, yards }) => {
  // Transform the API data into our table structure
  const transformEquipmentData = () => {
    if (!equipmentStatusData) return [];

    return Object.entries(equipmentStatusData).map(([section, yardData]) => {
      const items = [];
      
      // Collect all unique equipment across all yards for this section
      const allEquipment = new Set();
      Object.values(yardData).forEach(equipmentList => {
        equipmentList.forEach(item => {
          allEquipment.add(item.equipment);
        });
      });

      // Create items for each unique equipment
      Array.from(allEquipment).forEach((equipment, index) => {
        const equipmentItems = [];
        
        // Find this equipment in each yard
        yards.forEach(yard => {
          const yardEquipment = yardData[yard] || [];
          const found = yardEquipment.find(item => item.equipment === equipment);
          
          if (found) {
            equipmentItems.push({
              ...found,
              yard
            });
          } else {
            // Add empty entry if equipment doesn't exist for this yard
            equipmentItems.push({
              ser: `${index + 1}.`,
              equipment,
              yard,
              cat: '',
              po_date: '',
              po_no: '',
              oem_name: '',
              contractual_delivery_date: '',
              expected_delivery_date: '',
              present_status: ''
            });
          }
        });

        items.push({
          serialNo: `${index + 1}.`,
          equipment,
          yards: equipmentItems
        });
      });

      return {
        title: section,
        items
      };
    });
  };

  const sections = transformEquipmentData();

  return (
    <div className="flex flex-col items-center w-full bg-white text-black p-4">
      <div className="text-right w-full mb-2">
        <span className="font-semibold">Enclosure 5</span>
      </div>
      
      <h1 className="text-center font-bold text-lg mb-4 underline">STATUS OF EQUIPMENT</h1>
      
      <div className="overflow-x-auto w-full">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-black p-2 text-center w-12">Ser</th>
              <th className="border border-black p-2 text-center">Equipment</th>
              <th className="border border-black p-2 text-center w-16">Yard</th>
              <th className="border border-black p-2 text-center w-16">CAT</th>
              <th className="border border-black p-2 text-center">PO Date</th>
              <th className="border border-black p-2 text-center">PO No.</th>
              <th className="border border-black p-2 text-center">OEM Name</th>
              <th className="border border-black p-2 text-center">Contractual Delivery Date</th>
              <th className="border border-black p-2 text-center">Expected Delivery Date</th>
              <th className="border border-black p-2 text-center">Present Status</th>
            </tr>
          </thead>
          <tbody>
            {sections.map((section, sectionIndex) => (
              <React.Fragment key={sectionIndex}>
                {/* Section header */}
                <tr>
                  <td colSpan="10" className="border border-black p-1 text-center bg-yellow-300 font-bold">
                    {section.title}
                  </td>
                </tr>
                
                {/* Section items */}
                {section.items.length > 0 ? (
                  section.items.map((item, itemIndex) => (
                    <React.Fragment key={`${sectionIndex}-${itemIndex}`}>
                      {item.yards.map((yardItem, yardIndex) => (
                        <tr 
                          key={`${sectionIndex}-${itemIndex}-${yardIndex}`}
                          className={yardIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                        >
                          {yardIndex === 0 && (
                            <td 
                              rowSpan={item.yards.length} 
                              className="border border-black p-1 text-center align-middle"
                            >
                              {item.serialNo}
                            </td>
                          )}
                          {yardIndex === 0 && (
                            <td 
                              rowSpan={item.yards.length} 
                              className="border border-black p-1 align-middle"
                            >
                              {item.equipment}
                            </td>
                          )}
                          <td className="border border-black p-1 text-center">{yardItem.yard}</td>
                          <td className="border border-black p-1 text-center">{yardItem.cat}</td>
                          <td className="border border-black p-1 text-center">{yardItem.po_date}</td>
                          <td className="border border-black p-1 text-center">{yardItem.po_no}</td>
                          <td className="border border-black p-1 text-center">{yardItem.oem_name}</td>
                          <td className="border border-black p-1 text-center">{yardItem.contractual_delivery_date}</td>
                          <td className="border border-black p-1 text-center">{yardItem.expected_delivery_date}</td>
                          <td className="border border-black p-1 text-center">
                            {yardItem.present_status === true ? 'Yes' : 
                             yardItem.present_status === false ? 'No' : ''}
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="border border-black p-2 text-center">
                      No equipment data available
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EquipmentStatusTable;